//import { SnackBarModule } from "../../../modules/SnackBarModule";
import { AnalisarFeriasService } from "../../../services/AnalisarFeriasService";

export default {
  name: "AprovarFeriasLote",


  props:{
    selected:{
      default:""
    }
  },
  
  data: () => ({
    form: {},

    loading: {
      field: false,
      btn: false
    }
  }),


  methods: {
    prepareForm() {
      const formData = new FormData();

      this.selected.forEach( (element, index) => {
        formData.append(`idFeriasArray[${index}]`, element.idFerias)
      });
      this.sendForm(formData);
      return;
    },

 

    async sendForm(formData) {
      this.loading.btn = true;
      const response = await AnalisarFeriasService.aprovarFeriasLote(formData);
      this.loading.btn = false;
      if (response) {
        this.$emit('on-confirm');
        this.close();
      }
      this.loading.btn = false;
    },

   
    close() {
      this.$emit("on-close");
    },
  }
};